import React from "react";
import { Wrapper } from "./inSchedule.styles";
import massageDog from "../animatedGifs/tracker-scheduled-optimised.gif";

export const InSchedule = () => {
  return (
    <Wrapper>
      <img className="animated-gif-dog" src={massageDog} alt="hang in there!" />
      <h3>Hang in there!</h3>
      <p>
        Your application is currently being prioritised and will soon be
        assessed by one of our credit consultants.
      </p>
    </Wrapper>
  );
};
